import { IEmailTemplate } from "../../models/BaseModel";

export const EmptyEmailTemplate:IEmailTemplate ={
    id:undefined,
    templateSubject:"",
    templateName:"",
    templateBody:"",

}